import { render } from "./TeacherNavbar.vue?vue&type=template&id=693b47a0&scoped=true"
import script from "./TeacherNavbar.vue?vue&type=script&lang=js"
export * from "./TeacherNavbar.vue?vue&type=script&lang=js"

import "./TeacherNavbar.vue?vue&type=style&index=0&id=693b47a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693b47a0"]])

export default __exports__